var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.90918 15V17M12.9092 11V17M16.9092 7V17M8.70918 21H17.1092C18.7893 21 19.6294 21 20.2712 20.673C20.8356 20.3854 21.2946 19.9265 21.5822 19.362C21.9092 18.7202 21.9092 17.8802 21.9092 16.2V7.8C21.9092 6.11984 21.9092 5.27976 21.5822 4.63803C21.2946 4.07354 20.8356 3.6146 20.2712 3.32698C19.6294 3 18.7893 3 17.1092 3H8.70918C7.02902 3 6.18894 3 5.54721 3.32698C4.98272 3.6146 4.52378 4.07354 4.23616 4.63803C3.90918 5.27976 3.90918 6.11984 3.90918 7.8V16.2C3.90918 17.8802 3.90918 18.7202 4.23616 19.362C4.52378 19.9265 4.98272 20.3854 5.54721 20.673C6.18894 21 7.02902 21 8.70918 21Z",
    stroke: "#2ABDF0",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportActive);
export default __webpack_public_path__ + "static/media/ReportActive.cf765522af8cbe285b4e87d96d7166e8.svg";
export { ForwardRef as ReactComponent };